export default __webpack_public_path__ + "static/media/logout.4a3c460f.svg";